module.exports = __webpack_public_path__ + "static/tweetscout-logo-5f5ceaa26607f525b94d4c2dfc975e7f.png";